//import { helper } from "vuelidate/lib/validators";

export const isTimeDefaultValue = (value) => {
	// if (!helper.req(value)) {
	// 	return true
	// }
	return value === "hh:mm A"
}